import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    if (!items?.length) return ["This VariationComponent has no items"];

    const errorMessages = checkItemArrayIntegrity(items, ["headline"]);

    return errorMessages;
}
